import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      outerContainer: {
        alignItems: 'center',
        background: 'transparent',
        justifyContent: 'center',
        minWidth: '100%',
        padding: '0px 24px 24px 24px'
      },
      innerContainer: {
        background: 'white',
        borderRadius: '8px',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        height: '809px',
        minWidth: '100%',
        overflow: 'hidden',
        padding: '32px 64px 40px 64px',
        [theme.breakpoints.down('lg')]: {
          display: 'grid',
          gridTemplateRows: 'min-content min-content auto',
          height: '1640px',
          padding: '32px 0'
        }
      },
      headerContainer: {
        borderBottom: 'solid 2px #c8c8c8',
        padding: '0 0 16px',
        width: '100%',
        [theme.breakpoints.down('lg')]: {
          padding: '0 30px 16px'
        }
      },
      commonBenefitsContainer: {
        borderRight: 'solid 2px #c8c8c8',
        fontFamily: props.fontFamily,
        height: '600px',
        overflow: 'hidden',
        width: '50%',
        [theme.breakpoints.down('lg')]: {
          borderBottom: 'solid 2px #c8c8c8',
          borderRight: 'none',
          height: '602px',
          width: '100%'
        }
      },
      membershipLevelsContainer: {
        height: '600px',
        padding: '12px 0 0 32px',
        width: '50%',
        [theme.breakpoints.down('lg')]: {
          height: 'auto',
          minHeight: '600px',
          maxHeight: '830px',
          padding: '28px 30px 0',
          width: '100%'
        }
      },
      membershipLevelName: {
        flex: '1',
        margin: '0px 24px'
      }
    })
  );
